function prepareSlideLeft(root, elements, options = {}) {
    const delay = Number.isFinite(options.delay) ? options.delay : 0;
    const delayProperty = options.delayProperty || '--animate-delay';

    if (root?.dataset) {
        root.dataset.animateReady = '1';
        root.dataset.animateState = 'hidden';
        root.dataset.animateMotion = options.prefersReducedMotion ? 'reduced' : 'full';
    }

    elements.forEach((el, index) => {
        const itemDelay = delay + index * (Number.isFinite(options.stagger) ? options.stagger : 0);
        if (el?.style?.setProperty) {
            el.style.setProperty(delayProperty, `${itemDelay}ms`);
        }
        if (el?.dataset) {
            el.dataset.animateItem = '1';
            el.dataset.animateIndex = String(index);
            el.dataset.animateDelay = String(itemDelay);
        }
    });

    return {
        items: elements,
    };
}

function playSlideLeft(root) {
    if (root?.dataset) {
        root.dataset.animateState = 'visible';
    }
}

const slideLeft = {
    name: 'slide-left',
    targetSelector: '[data-animate-item="1"]',
    prepare: prepareSlideLeft,
    play: playSlideLeft,
};

export {
    playSlideLeft,
    prepareSlideLeft,
    slideLeft,
};
